<mat-card #appTable class="expanded-table-container">
  <mat-expansion-panel
    class="expanded-table mat-elevation-z0"
    hideToggle
    [ngClass]="{ 'expanded-height': isExpanded && tableConf.detailsHref }"
    [disabled]="disabled"
    [expanded]="expandableTableState === ExpandableTableState.Expanded"
    (opened)="isExpanded = true"
    (closed)="isExpanded = false"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5 *ngIf="title" class="title">
          <ng-container *ngIf="titleHref; else plainTitle">
            <a [ixTest]="[title, 'open-in-new']" [routerLink]="titleHref">
              {{ title }}
              <ix-icon name="open_in_new" class="title-icon"></ix-icon>
            </a>
          </ng-container>
          <ng-template #plainTitle>{{ title }}</ng-template>
        </h5>

        <div class="header-custom-content">
          <ng-content select="[headerCustomContent]"></ng-content>
        </div>
      </mat-panel-title>
      <mat-panel-description class="description-panel">
        <div class="actions">
          <ix-tooltip
            *ngIf="tableConf.tooltip"
            [header]="tableConf.tooltip.header | translate"
            [message]="tableConf.tooltip.message | translate"
          ></ix-tooltip>
          <button
            *ngIf="tableConf.configure"
            mat-button
            color="default"
            class="action-icon action-button"
            [ixTest]="['configure', tableConf.name]"
            (click)="tableConf.configure()"
          >
            {{ 'Configure' | translate }}
          </button>

          <button
            *ngIf="tableConf.add"
            mat-button
            color="default"
            class="action-icon action-button"
            [ixTest]="['add', tableConf.name]"
            [disabled]="tableConf.addActionDisabled"
            (click)="tableConf.add()"
          >
            {{ tableConf.addButtonLabel ? tableConf.addButtonLabel : ('Add' | translate) }}
          </button>

          <ng-content select="[headerCustomActions]"></ng-content>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ix-conf-table #tableComponent [conf]="tableConf"></ix-conf-table>
  </mat-expansion-panel>
  <div
    *ngIf="isExpanded && tableConf.detailsHref"
    id="actions-row"
    [ngClass]="{ 'actions-row': isExpanded && tableConf.detailsHref }"
  >
    <div>
      <a [ixTest]="[tableConf.name, 'view-all']" [routerLink]="tableConf.detailsHref.split('/')">
        {{ 'View All' | translate }}
      </a>
    </div>
  </div>
</mat-card>
